import { useMemo } from 'react'
import { useSyncExternalStore } from 'use-sync-external-store/shim'
import { PwaPromptStore } from './pwaNotificationStore'

export const usePwaNotificationStore = () => {
  const state = useSyncExternalStore(PwaPromptStore.subscribe, PwaPromptStore.getSnapshot)

  const methods = useMemo(() => ({ setShown: PwaPromptStore.setShown, setDismissed: PwaPromptStore.setClosed }), [])

  return { state, methods }
}
